import { YoutubeDirectPostDraft, YoutubeVisibility } from "../store/api-actions";
import { PostType } from "../../socialPost/enums/postType";

export interface YoutubeDirectPostPayload {
  title: string;
  category: string;
  tags: string[];
  visibility: YoutubeVisibility;
  madeForKids: boolean;
  notifySubscribers: boolean;
  isShort: boolean;
}

export function buildYoutubeDirectPostPayload(
  draft: YoutubeDirectPostDraft,
  postType: PostType
): YoutubeDirectPostPayload | null {
  if (!draft.title.trim()) {
    return null;
  }
  const tags = draft.tags
    .split(",")
    .map((tag) => tag.trim())
    .filter(Boolean)
    .slice(0, 30);
  return {
    title: draft.title.trim().slice(0, 100),
    category: draft.category,
    tags,
    visibility: draft.visibility,
    madeForKids: draft.madeForKids,
    notifySubscribers: draft.notifySubscribers,
    isShort: postType === PostType.SHORT,
  };
}

export function getYoutubePublishBlockReason(
  draft: YoutubeDirectPostDraft,
  hasVideo: boolean,
  postType: PostType,
  videoDurationSec?: number | null
): string | null {
  if (!hasVideo) {
    return "YouTube requiere un video para publicar.";
  }
  if (!draft.title.trim()) {
    return "Completá el título del video en las opciones de YouTube.";
  }
  if (postType === PostType.SHORT && videoDurationSec != null && videoDurationSec > 60) {
    return "Los Shorts deben durar 60 segundos o menos.";
  }
  return null;
}
